import { Button, Heading, Text } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";

type FinalCtaProps = {
  id: string;
  title: string;
  text: string;
  ctaLabel: string;
  onCtaClick: () => void;
};

// Faixa escura: on-solid sobre ink-900 e ink-200 sobre ink-900 passam de 12:1.
export const FinalCta = ({
  id,
  title,
  text,
  ctaLabel,
  onCtaClick,
}: FinalCtaProps) => (
  <PageSection labelledBy={`${id}-title`}>
    <div className="bg-ds-ink-900 rounded-ds-xl flex flex-col items-center gap-6 px-6 py-14 text-center sm:py-20">
      <Heading
        level={2}
        id={`${id}-title`}
        className="text-ds-on-solid max-w-2xl"
      >
        {title}
      </Heading>
      <Text size="lead" className="text-ds-ink-200 max-w-xl">
        {text}
      </Text>
      <Button size="lg" onClick={onCtaClick} className="w-full sm:w-auto">
        {ctaLabel}
      </Button>
    </div>
  </PageSection>
);
